import { useTypedMutation } from '../helpers/useTypedMutation';
import { usePostUpdateCache } from './post.cache';

export const usePostSetReadMutation = (post_id: number) => {
  const postUpdateCache = usePostUpdateCache(post_id);
  return useTypedMutation('put', `/communication/press/{post_id}/set_read`, {
    params: {
      path: {
        post_id
      }
    },
    mutationOpts: {
      onSuccess(_data, _variables, _context) {
        // Change favorite value to post in cache
        postUpdateCache((oldPost: any) =>
          oldPost
            ? {
                ...oldPost,
                is_read: true
              }
            : oldPost
        );
      }
    }
  });
};

export const usePostSetMultipleReadMutation = (post_ids: number[]) => {
  return useTypedMutation('put', '/communication/press/set_read_bulk', {
    params: {
      query: {
        post_ids
      }
    }
  });
};

export const usePostSetFavoriteMutation = (post_id: number) => {
  const postUpdateCache = usePostUpdateCache(post_id);
  return useTypedMutation(
    'put',
    `/communication/press/{post_id}/set_favorite`,
    {
      params: {
        path: {
          post_id
        }
      },
      mutationOpts: {
        onSuccess(_data, _variables, _context) {
          // Change favorite value to post in cache
          postUpdateCache((oldPost: any) =>
            oldPost
              ? {
                  ...oldPost,
                  is_favorite: !oldPost.is_favorite
                }
              : oldPost
          );
        }
      }
    }
  );
};

export const usePostSetMultipleFavoriteMutation = (post_ids: number[]) => {
  return useTypedMutation('put', '/communication/press/set_favorite_bulk', {
    params: {
      query: {
        post_ids
      }
    }
  });
};

export const usePostAddTagMutation = (post_id: number) => {
  const postUpdateCache = usePostUpdateCache(post_id);

  return useTypedMutation('post', `/communication/press/{post_id}/add_tag`, {
    params: {
      path: {
        post_id
      }
    },
    mutationOpts: {
      onSuccess(data, _variables, _context) {
        // If no data, it means the tag was not created
        if (!data) {
          return;
        }
        // Add associated tag to post in cache
        postUpdateCache((oldPost: any) => {
          return oldPost
            ? {
                ...oldPost,
                tags: [...oldPost.tags, data]
              }
            : oldPost;
        });
      }
    }
  });
};

export const usePostRemoveTagMutation = (post_id: number) => {
  const postUpdateCache = usePostUpdateCache(post_id);
  return useTypedMutation('post', `/communication/press/{post_id}/remove_tag`, {
    params: {
      path: {
        post_id
      }
    },
    mutationOpts: {
      onSuccess(data, _variables, _context) {
        // If no data, it means the tag was not removed
        if (!data) {
          return;
        }
        // Remove associated tag from post in cache
        postUpdateCache((oldPost: any) => {
          return oldPost
            ? {
                ...oldPost,
                tags: oldPost.tags.filter(
                  ({ id }: { id: number }) => id !== data.id
                )
              }
            : oldPost;
        });
      }
    }
  });
};

export const usePostShareMutation = (post_id: number) => {
  return useTypedMutation('post', `/communication/press/{post_id}/share`, {
    params: {
      path: {
        post_id
      }
    }
  });
};

export const usePostDownloadMutation = (post_id: number) => {
  return useTypedMutation('get', `/communication/press/{post_id}/pdf`, {
    params: {
      path: {
        post_id
      }
    }
  });
};
